var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4236 0.904287C20.5025 0.983022 20.5651 1.07656 20.6079 1.17953C20.6506 1.28251 20.6726 1.3929 20.6726 1.50439C20.6726 1.61588 20.6506 1.72627 20.6079 1.82924C20.5651 1.93222 20.5025 2.02575 20.4236 2.10449L1.77641 20.7517C1.61725 20.9108 1.40139 21.0002 1.17631 21.0002C0.951225 21.0002 0.735363 20.9108 0.576206 20.7517C0.41705 20.5925 0.327637 20.3766 0.327637 20.1516C0.327637 19.9265 0.41705 19.7106 0.576206 19.5515L19.2234 0.904287C19.3021 0.825354 19.3957 0.762728 19.4986 0.719998C19.6016 0.677268 19.712 0.655273 19.8235 0.655273C19.935 0.655273 20.0454 0.677268 20.1483 0.719998C20.2513 0.762728 20.3449 0.825354 20.4236 0.904287Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.576162 0.904287C0.497229 0.983022 0.434603 1.07656 0.391873 1.17953C0.349143 1.28251 0.327148 1.3929 0.327148 1.50439C0.327148 1.61588 0.349143 1.72627 0.391873 1.82924C0.434603 1.93222 0.497229 2.02575 0.576162 2.10449L19.2233 20.7517C19.3825 20.9108 19.5984 21.0002 19.8234 21.0002C20.0485 21.0002 20.2644 20.9108 20.4235 20.7517C20.5827 20.5925 20.6721 20.3766 20.6721 20.1516C20.6721 19.9265 20.5827 19.7106 20.4235 19.5515L1.77636 0.904287C1.69763 0.825354 1.60409 0.762728 1.50112 0.719998C1.39814 0.677268 1.28775 0.655273 1.17626 0.655273C1.06477 0.655273 0.954381 0.677268 0.851406 0.719998C0.748431 0.762728 0.654897 0.825354 0.576162 0.904287Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/close-btn.a28727c866f7bff46dfd84015143699b.svg";
export { ForwardRef as ReactComponent };